import * as React from 'react'

// Components
import LimitLeft from './components/limit-left'
import LimitReached from './components/limit-reached'
import PlanInfo from './components/info'

// Constants
// import { LIMIT_TYPE } from '../../constants';

const DSAgreementEnterprise = ({ agreement, isRepeated }) => {
  const { limit_type } = agreement.can_download_content || {}

  if (limit_type !== 'none') {
    return <LimitReached agreement={agreement} />
  }

  return (
    <>
      <LimitLeft agreement={agreement} isRepeated={isRepeated} />
      <PlanInfo agreement={agreement} />
    </>
  )
}
export default DSAgreementEnterprise
